import React, { useState } from "react";
import { db, storage } from "../firebaseConfig";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "../styles/AddModelStyle.scss";

const AddModel: React.FC = () => {
  const [form, setForm] = useState({
    name: "",
    category: "Women",
    height: "",
    bust: "",
    waist: "",
    hips: "",
    shoe: "",
    eyes: "",
    hair: "",
    instagramHandle: "",
  });

  const [images, setImages] = useState<File[]>([]);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setImages(Array.from(e.target.files));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const uploadPromises = images.map(async (file) => {
        const fileRef = ref(storage, `models/${Date.now()}_${file.name}`);
        await uploadBytes(fileRef, file);
        return await getDownloadURL(fileRef);
      });

      const imageArray = await Promise.all(uploadPromises);

      await addDoc(collection(db, "models"), {
        ...form,
        images: imageArray,
        createdAt: Timestamp.now(),
      });

      alert("Model added successfully!");

      // Reset form
      setForm({
        name: "",
        category: "Women",
        height: "",
        bust: "",
        waist: "",
        hips: "",
        shoe: "",
        eyes: "",
        hair: "",
        instagramHandle: "",
      });
      setImages([]);
    } catch (error) {
      console.error("Error adding model:", error);
      alert("Failed to add model.");
    }

    setSubmitting(false);
  };

  return (
    <div className="add-model-page">
      <h2>Add New Model</h2>
      <form onSubmit={handleSubmit}>
        <input name="name" placeholder="Name" value={form.name} onChange={handleChange} required />
        <select name="category" value={form.category} onChange={handleChange}>
          <option value="Women">Women</option>
          <option value="Men">Men</option>
        </select>
        <input name="height" placeholder="Height" value={form.height} onChange={handleChange} />
        <input name="bust" placeholder="Bust" value={form.bust} onChange={handleChange} />
        <input name="waist" placeholder="Waist" value={form.waist} onChange={handleChange} />
        <input name="hips" placeholder="Hips" value={form.hips} onChange={handleChange} />
        <input name="shoe" placeholder="Shoe Size" value={form.shoe} onChange={handleChange} />
        <input name="eyes" placeholder="Eye Color" value={form.eyes} onChange={handleChange} />
        <input name="hair" placeholder="Hair Color" value={form.hair} onChange={handleChange} />
        <input name="instagramHandle" placeholder="Instagram Handle" value={form.instagramHandle} onChange={handleChange} />

        <label className="file-label">
          Upload Model Images (Multiple)
          <input type="file" accept="image/*" multiple onChange={handleFileChange} />
        </label>

        <button type="submit" disabled={submitting}>
          {submitting ? "Uploading..." : "Add Model"}
        </button>
      </form>
    </div>
  );
};

export default AddModel;